import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import logo from "./LogoAppleTreeHD.svg";

const KYCCompleted = () => {
  const [params] = useSearchParams();
  const wallet = params.get("wallet");
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.backgroundColor = "#000"; //sfondo nero
    document.body.style.color = "#fff";
  })

  useEffect(() => {
    console.log("✅ KYCCompleted loaded. Wallet param:", wallet);

   // Redirect automatico dopo 8 secondi (opzionale)
   const timer = setTimeout(() => {
    console.log("redirecting...");
    navigate("/");
  }, 10000);
  
  return () => clearTimeout(timer);
  }, [wallet, navigate]);

  return (
    <div style={{ 
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      padding: "20px",
      textAlign: "center"
    }}>
      <img 
        src={logo} 
        alt="AppleTree Logo" 
        style={{ width: "120px", marginBottom: "30px" }} 
      />
      
      <div style={{ fontSize: "48px", color: "#20f804", marginBottom: "10px" }}>✔</div>
      <h1 style={{ marginBottom: "10px" }}>KYC Completed</h1>
      <p style={{ color: "#ccc" }}>Connected Wallet:</p>

      <div style={{
        backgroundColor: "#111",
        color: "#20f804",
        padding: "12px 16px",
        borderRadius: "8px",
        fontFamily: "monospace",
        wordBreak: "break-word",
        maxWidth: "90%",
        marginBottom: "20px"
      }}>
        {wallet || "No wallet detected"}
      </div>

      <button
        onClick={() => navigate("/")}
        style={{
          backgroundColor: "#20f804",
          color: "#000",
          padding: "10px 20px",
          borderRadius: "8px",
          fontWeight: "bold",
          cursor: "pointer"
        }}
      >
        Return to dApp
      </button>

      <p style={{ color: "#aaa", fontSize: "0.9rem", marginTop: "15px" }}>
        You will be automatically redirected shortly...
      </p>
    </div>
  );
};

export default KYCCompleted;